import React, { useMemo } from 'react';

import { Button, Flex, Space, Table, type TableColumnsType } from 'antd';
import cronstrue from 'cronstrue/i18n';
import { useNavigate } from 'react-router-dom';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Periodicity } from 'src/interfaces/entities/periodicity';
import EditCron from 'src/pages/cron/ListCronsPage/components/EditCron';
import DeleteCron from 'src/pages/cron/ListCronsPage/components/DeleteCron';
import { useGetAllPeriodicitiesQuery } from 'src/redux/services/centralApi';
import dayjs from 'dayjs';

export default function ListCronsPage() {
	const navigate = useNavigate();

	const {
		data: allPeriodicitiesData,
		refetch,
		isLoading: isLoadingAllPeriodicitiesData,
		isFetching: isFetchingPeriodicities,
	} = useGetAllPeriodicitiesQuery();

	const columns = useMemo<TableColumnsType<Periodicity<'persisted'>>>(
		() => [
			{
				dataIndex: 'alias',
				title: 'Apelido',
				key: 'alias',
			},
			{
				dataIndex: 'cron_expression',
				title: 'Expressão cron',
				key: 'cron_expression_raw',
			},
			{
				dataIndex: 'cron_expression',
				title: 'Expressão humanizada',
				key: 'cron_expression_human',
				render: (value: string) => {
					try {
						return cronstrue.toString(value, { locale: 'pt_BR', });
					} catch {
						return value;
					}
				},
			},
			{
				dataIndex: 'creation_date',
				title: 'Data de Criação',
				key: 'creation_date',
				sorter: (a, b) => {
					const dateA = a.creation_date ? dayjs(a.creation_date) : null;
					const dateB = b.creation_date ? dayjs(b.creation_date) : null;

					if (dateA && dateB && dateA.isValid() && dateB.isValid()) {
						return dateA.diff(dateB);
					}
					if (!dateA && !dateB) return 0;
					if (!dateA) return 1;
					if (!dateB) return -1;
					return 0;
				},
			},
			{
				title: 'Ações',
				key: 'actions',
				render: (_, record) => (
					<Space>
						<DeleteCron row={record} />
						<EditCron row={record} />
					</Space>
				),
			},
		],
		[]
	);

	return (
		<DashboardTemplate pageTitle="Listar crons">
			<Flex style={{ padding: 5, marginBottom: 8, }} gap={8} justify="end">
				<Button
					type="primary"
					onClick={() => navigate('/cron/adicionar')}
					icon={<PlusOutlined />}
				>
Adicionar
				</Button>
				<Button
					type="text"
					onClick={refetch}
					icon={<ReloadOutlined />}
				/>
			</Flex>
			<Table<Periodicity<'persisted'>>
				columns={columns}
				dataSource={allPeriodicitiesData ?? []}
				rowKey="periodicity_id"
				loading={isLoadingAllPeriodicitiesData || isFetchingPeriodicities}
				size="small"
			/>
		</DashboardTemplate>
	);
}
